import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import disallow_45direct_45url_45access_45global from "/src/middleware/disallowDirectUrlAccess.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  disallow_45direct_45url_45access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}